import { Box, Container, IconButton } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import { FooterLinks, FooterSocialLinks } from "common/SiteLinks"
import FooterMcIcon from "components/Icons/FooterMcIcon"
import MintIcon from "components/Icons/RedesignIcons/MintIcon"
import NextLink from "components/Reusable/Bit/NextLink"
import { useRouter } from "next/router"
import styled from "styled-components"
import colors from "theme/colors"
import FooterLinkList from "./FooterLinkList"
import FooterSocialLinksList from "./FooterSocialLinksList"

const StyledBox = styled(Box)<{ $pathname?: string }>`
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    justify-content: center;
    height: auto;
    padding: 0px;
    padding-bottom: 100px;
    ${(p) => p?.$pathname === "/" && `padding-bottom: 10px;`}
  }
`

const StyledContainer = styled(Container)`
  padding: 40px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`

const StyledSvgWrap = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
  a {
    padding: 0px;
  }
`

const StyledLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  a {
    height: 20px;
    line-height: 20px;
  }
`

const StyledCaption = styled.p`
  font-family: Speedee;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.22px;
  text-align: left;
  color: ${colors.black};
  margin-right: 8px;
`

const StyledSocialContainer = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    justify-content: center;

    > * {
      margin: 0;
    }
  }
`

const StyledIconButton = styled(IconButton).attrs({
  "aria-label": "מעבר לעמוד הבית של מקדונלדס",
})<{ href: string; target: string }>``

const Footer = () => {
  const { pathname } = useRouter()
  const isDesktop = useIsDesktop()
  return (
    <>
      <StyledBox $pathname={pathname}>
        <StyledContainer>
          <StyledSvgWrap>
            <NextLink href="/" ariaLabel="מעבר לעמוד הבית של מקדונלדס" passHref>
              <StyledIconButton color="inherit" href="/" target="_self">
                <FooterMcIcon w={isDesktop ? 60 : 50} h={isDesktop ? 60 : 50} />
              </StyledIconButton>
            </NextLink>
          </StyledSvgWrap>
          <FooterLinkList linkList={FooterLinks} />
          <StyledSocialContainer>
            <FooterSocialLinksList linkList={FooterSocialLinks.links} />
          </StyledSocialContainer>
        </StyledContainer>
        <StyledLogoContainer>
          <NextLink openInNewTab href="https://mintapp.co.il">
            <MintIcon />
          </NextLink>
          <StyledCaption>Created by</StyledCaption>
        </StyledLogoContainer>
      </StyledBox>
    </>
  )
}

export default Footer
